"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/*
 * This script scrolls to top after the calendar hides
 */
var waitForElement_1 = require("../../../../../ww_project/Resources/Private/app/helpers/waitForElement");
var CompusoftCalendarScrollTop = /** @class */ (function () {
    function CompusoftCalendarScrollTop() {
        (0, waitForElement_1.waitForElement)('#CalendarWrapper').then(function (element) {
            // Listen to DOM changes if compusoft decides to randomly update the filter content
            var config = { attributes: true, childList: false, subtree: false };
            var callback = function (mutationList) {
                for (var _i = 0, mutationList_1 = mutationList; _i < mutationList_1.length; _i++) {
                    var mutation = mutationList_1[_i];
                    if (mutation.type === 'attributes' && element.style.display == 'none') {
                        window.scrollTo({ top: 0, behavior: 'smooth' });
                    }
                }
            };
            var observer = new MutationObserver(callback);
            observer.observe(element, config);
        });
    }
    return CompusoftCalendarScrollTop;
}());
exports.default = CompusoftCalendarScrollTop;
